import './i18next.d';

import { use } from 'i18next';
import { initReactI18next } from 'react-i18next';

import en from '../../translations/en.json';

export const defaultNamespace = 'translation';
export const resources = {
  en: {
    translation: en,
  },
} as const;

export const initI18n = async (): Promise<void> => {
  const locale = navigator.languages[0] ?? 'en';

  // eslint-disable-next-line react-hooks/rules-of-hooks
  await use(initReactI18next).init({
    defaultNS: defaultNamespace,
    resources,
    lng: locale,
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });
};
